export default function formControl({ variables, }) {
    return {
        MuiFormControl: {
            defaultProps: {
                variant: "outlined",
            },
        },
        MuiNativeSelect: {
            styleOverrides: {
                select: {
                    fontWeight: variables.font_weight_medium,
                },
                icon: {
                    color: variables.border_strong,
                },
            },
        },
    };
}
//# sourceMappingURL=formControl.js.map